import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { APIV2_URL } from './constants';

interface Payload {
  paymentType: string;
  billingCountry: string;
  signature: string;
  paymentMethodId?: number;
  stripeToken?: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, data: Payload) =>
    makeCall<Conversation>(
      'PUT',
      `${APIV2_URL}/conversation/${conversationId}/payment`,
      { data },
    );
